import React, { useCallback, useState } from 'react';

import { Divider } from '@material-ui/core';

import { Collapsible, FormFieldWrapper } from '../Global';
import { ColorPicker, ImageUpload, TextInput, /*TextItemList,*/ Select, RichTextEditor } from '../EditorFormElements';
import { Details } from '.';

import { themeColors } from '../../config/progression'
import makePath from '../../utils/makePath'

// Each topic is a "page" in the Progression
export const Topic = React.memo (({given = {}, index, ...props }) => {
  const [label, setLabel] = useState( given.title ? given.title : `Topic ${index + 1}`)

  const callback = useCallback((name,value) => setLabel(value), [setLabel]);

  const path = makePath(props.path,index);

  return (
    <Collapsible headerTag="h4" title={label} sortableChild>

      <FormFieldWrapper>

        <TextInput 
          name="title"
          label="Tab Label"
          defaultText={`Topic ${index + 1}`}
          path={path}
          callback={callback}
          given={given.title}
        />


        <ColorPicker 
          label="Color Theme"
          name="theme" 
          path={path}
          given={given.theme}
          colors={themeColors}
        />

      </FormFieldWrapper>

      <Divider />

      <Collapsible title="Introduction Section" grayTheme>

        <FormFieldWrapper>

          <ImageUpload 
            name="bg"
            label="Background Image"
            tooltip="Upload an image to display as the background. Image size must be 1300px by 1140px and not exceed 250KB."
            path={path}
            given={given.bg}
          /> 

          <TextInput 
            name="subtitle1"
            label="Lead-in"
            defaultText="Enter lead-in text"
            path={path}
            given={given.subtitle1}
          />

          <RichTextEditor
            name="listItems"
            label="Lead-in List"
            defaultValue="<ul><li>Item 1</li><li>Item 2</li></ul>"
            controls={['bulletList']}
            inlineToolbarControls={false}
            disallowIndent
            given={given.listItems}
            path={path}
          />

          <Divider />

          <TextInput 
            name="subtitle2a"
            label="Heading"
            defaultText="Heading"
            path={path}
            given={given.subtitle2a}
          />

          <TextInput 
            name="subtitle2b"
            label="Subheading"
            defaultText="Subheading"
            path={path}
            given={given.subtitle2b}
          />

          <Select
            label="Subheading size"
            name="smallSubtitle2b"
            path={path}
            options={[
              {value: 'lg', label: 'Large'},
              {value: 'md', label: 'Medium'}
            ]}
            given={given.smallSubtitle2b}
          />

        </FormFieldWrapper>

      </Collapsible>
      
      <Details
        path={path}
        detailsLayout={props.detailsLayout}
        // topicLayout={props.topicLayout}
        given={given.details}
      />

      {props.deleteBtn}

    </Collapsible>
  )

})